<template>
  <div v-if="userInfo.orgId==='614867004922269697'" class="tab-block">
    <div v-for="(item,index) in tabList" :key="index" :class="active===index?'tab-item-active':''" class="tab-item" @click="handleChangeTab(item,index)">
      <img :src="item.img" alt="">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      tabList: [
        {
          img: require('@assets/img/tab_data@2x.png'),
          routerName: 'dataStatistics_dataStatistics'
        },
        {
          img: require('@assets/img/tab_sys@2x.png'),
          routerName: 'financeCenter_settlement_edu'
        }

      ]
    };
  },
  computed: {
    ...mapState(['userInfo']),
    active() {
      if (this.$route.name === 'dataStatistics_dataStatistics') {
        return 0;
      } else {
        return 1;
      }
    }
  },
  methods: {
    handleChangeTab(item, index) {
      this.$router.push({ name: item.routerName });
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-block{
  display: flex;
  flex-direction: column;
  position: fixed;
  right: -2px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1000;
  .tab-item{
    width: 40px;
    height: 131px;
    z-index: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .tab-item+.tab-item{
    margin-top: -15px;
  }
  .tab-item-active{
    z-index: 10000;
  }
}
</style>
